import { FC } from 'react';
import { useIntl } from 'react-intl';
import { ImageBoxFuture } from './image-box-future';

const requiredGrayIcon = '/images/private-booking/requiredGray.svg';

export const RequiredGrayIcon: FC = () => {
  const intl = useIntl();
  return (
    <ImageBoxFuture
      img={requiredGrayIcon}
      title={intl.formatMessage({
        id: 'global.all_required',
      })}
      objectFit='contain'
      sx={{
        mr: '8px',

        height: '24px',
        width: '24px',
      }}
    />
  );
};

export default RequiredGrayIcon;
